import axios from "axios";
import { CORREO_USUARIO } from "config/general/Configuracion";
import { API_CONFIGURACION } from "config/general/Configuracion";
import { ID_CUENTA } from "config/general/Configuracion";
import { HEADERS, apiTimeout } from "config/general/Configuracion";


const DispositivosEnUsoApiHelper = {

    listarDispositivosEnUso: async () => {
        try {
            const url = `${API_CONFIGURACION}/v1/configuracion/listar_dispositivos_en_uso/${sessionStorage[ID_CUENTA]}`;
            const response = await axios.get(url, {
                headers: HEADERS(),
                timeout: apiTimeout
            });
            return response.data;
        } catch (error) {
            console.error("Error al listar dispositivos en uso:", error);
            throw error;
        }
    },
};

export default DispositivosEnUsoApiHelper;
